import Maps from "src/components/maps/maps";
import { mapsLoader } from "src/components/maps/actions_loaders";
import Assignments from "src/components/assignments/Assignments";
import Approvals from "src/components/approvals/Approvals";
import { approvalsLoader } from "src/components/approvals/actions_loaders";
import ProposalList from "src/components/proposals/ProposalList";
import ProposalDetail from "src/components/proposals/ProposalDetail";
import ProposalForm from "src/components/proposals/ProposalForm";
import ProposalFilterForm from "src/components/proposals/ProposalFilterForm";
import ProposalExportForm from "src/components/proposals/ProposalExportForm";
import { approveProposalAction, deleteProposalAction, notifyProposalAction, proposalAction, proposalExportAction, proposalLoader, proposalsLoader, validateProposalAction, voidProposalAction } from "src/components/proposals/actions_loaders";
import Dashboard from "src/components/dashboard/Dashboard";
import { dashboardLoader } from "src/components/dashboard/actions_loaders";
import Reports from "src/components/reports/Reports";
import Detail from "src/components/reports/detail";
import ReportFilterForm from "src/components/reports/filter";
import ReportForm from "src/components/reports/reportForm";
import { reportLoader, reportsLoader } from "src/components/reports/actions_loaders";
import ProfitMargin from "src/components/profitMargin/ProfitMargin";
import { profitMarginLoader } from "src/components/profitMargin/actions_loaders";
import FleetUsage from "src/components/fleetUsage/FleetUsage";
import { fleetUsageLoader } from "src/components/fleetUsage/actions_loaders";
import LaborUsage from "src/components/LaborUsage/LaborUsage";
import { laborUsageLoader } from "src/components/LaborUsage/actions_loaders";
import Fleet from "src/components/fleets/fleets";
import FleetDetail from "src/components/fleets/FleetDetail";
import { FleetAddRoute, FleetEditRoute, FleetInventoryRoute, FleetSettingsRoute, FleetYardRoute, FleetYardsRoute } from "src/components/fleets/FleetRouteActions";
import { fleetLoader, fleetsLoader } from "src/components/fleets/actions_loaders";
import Hours from "src/components/hours/hours";
import { hoursLoader } from "src/components/hours/actions_loaders";
import ProjectCalendar from "src/components/projectCalendar/projectCalendar";
import Billings from "src/components/billings/billings";
import BillingDetail from "src/components/billings/detail";
import BillingForm from "src/components/billings/billingForm";
import BillingsExportRoute from "src/components/billings/export";
import Payroll from "src/components/payroll/payroll";
import { payrollLoader } from "src/components/payroll/actions_loaders";
import LaborCost from "src/components/laborCost/laborCost";
import { laborCostAction, laborCostLoader } from "src/components/laborCost/actions_loaders";
import ImportedBilling from "src/components/importedBilling/importedBilling";
import { importedBillingAction, importedBillingLoader } from "src/components/importedBilling/actions_loaders";
import JobTags from "src/components/JobTags/jobTags";
import OffCalendar from "src/components/offCalendar/OffCalendar";
import { offCalendarLoader } from "src/components/offCalendar/actions_loaders";
import Standby from "src/components/outside/standby/Standby";
import StandbyForm from "src/components/outside/standby/standbyForm";
import { standbyLoader } from "src/components/outside/standby/actions_loaders";
import Locator from "src/components/outside/locator/Locator";
import { locatorLoader } from "src/components/outside/locator/actions_loaders";
import Calendar from "src/components/calendar/Calendar";
import { calendarLoader } from "src/components/calendar/actions_loaders";
import AllLocatorList from "src/components/allOutside/locator/AllLocatorList";
import AllLocatorDetail from "src/components/allOutside/locator/AllLocatorDetail";
import AllLocatorDayEdit from "src/components/allOutside/locator/AllLocatorDayEdit";
import AllLocatorEmergencyEdit from "src/components/allOutside/locator/AllLocatorEmergencyEdit";
import {
    allLocatorAddEmergencyAction,
    allLocatorDeleteEmergencyAction,
    allLocatorDetailLoader,
    allLocatorListLoader,
    allLocatorSwitchDayAction,
    allLocatorSwitchWeekAction,
    allLocatorWithdrawAction,
} from "src/components/allOutside/locator/actions_loaders";
import AllStandbyList from "src/components/allOutside/standby/AllStandbyList";
import AllStandbyDetail from "src/components/allOutside/standby/AllStandbyDetail";
import { allStandbyDetailLoader, allStandbyListLoader, allStandbySwitchWeekAction } from "src/components/allOutside/standby/actions_loaders";
import PlannedOT from "src/components/outside/pot/PlannedOT";
import { plannedOTAction, plannedOTLoader } from "src/components/outside/pot/actions_loaders";
import EmergencyOT from "src/components/outside/eot/EmergencyOT";
import { emergencyOTAction, emergencyOTLoader } from "src/components/outside/eot/actions_loaders";
import DailyCallOut from "src/components/outside/daily/DailyCallOut";
import { dailyCallOutAction, dailyCallOutLoader } from "src/components/outside/daily/actions_loaders";
import CheckIn from "src/components/outside/checkIn/CheckIn";
import { checkInAction, checkInLoader } from "src/components/outside/checkIn/actions_loaders";
import AllPlannedOT from "src/components/allOutside/pot/AllPlannedOT";
import { allPlannedOTLoader, unlockPlannedOTAction } from "src/components/allOutside/pot/actions_loaders";
import AllEmergencyOT from "src/components/allOutside/eot/AllEmergencyOT";
import { allEmergencyOTLoader, unlockEmergencyOTAction } from "src/components/allOutside/eot/actions_loaders";
import AllDailyCallOut from "src/components/allOutside/daily/AllDailyCallOut";
import { allDailyCallOutLoader, unlockAllDailyCallOutAction } from "src/components/allOutside/daily/actions_loaders";
import AllCheckIn from "src/components/allOutside/checkIn/AllCheckIn";
import { allCheckInLoader, unlockCheckInAction } from "src/components/allOutside/checkIn/actions_loaders";
import DocumentsPage from "src/components/documents/DocumentsPage";
import { makeDocumentsAction, makeDocumentsLoader } from "src/components/documents/actions_loaders";
import NewspaperList from "src/components/newspaper/NewspaperList";
import NewspaperForm from "src/components/newspaper/NewspaperForm";
import { articleAction, articleLoader, newspaperLoader, newspaperMutationAction } from "src/components/newspaper/actions_loaders";
import Help from "src/components/help/Help";
import { helpAction } from "src/components/help/actions_loaders";
import RentalStatusList from "src/components/rentalStatus/RentalStatusList";
import RentalStatusDetail from "src/components/rentalStatus/RentalStatusDetail";
import RentalForm from "src/components/rentalStatus/RentalForm";
import ReturnForm from "src/components/rentalStatus/ReturnForm";
import { rentalAction, rentalLoader, rentalsLoader, returnAction } from "src/components/rentalStatus/actions_loaders";
import OutsideDivision from "src/components/outside/outsideDivision/OutsideDivision";
import { outsideDivisionsAction, outsideDivisionsLoader } from "src/components/outside/outsideDivision/actions_loaders";

import tasksimg from "src/img/tabs/tasks.png";
import projectsimg from "src/img/tabs/projects.png";
import worksimg from "src/img/tabs/works.png";
import assignmentsimg from "src/img/tabs/assignments.png";
import mapimg from "src/img/tabs/map.png";
import vendorimg from "src/img/tabs/vendor.png";
import purchasesimg from "src/img/tabs/purchases.png";
import perdiemimg from "src/img/tabs/perDiem.png";
import projectcalendarimg from "src/img/tabs/projectcalendar.png";
import jobtagsimg from "src/img/tabs/jobtag.png";
import reportsimg from "src/img/tabs/reports.png";
import personelimg from "src/img/tabs/personel.png";
import servicesimg from "src/img/tabs/services.png";
import fleetimg from "src/img/tabs/fleet.png";
import leadsimg from "src/img/tabs/leads.png";
import opportunitiesimg from "src/img/tabs/opportunities.png";
import contactsimg from "src/img/tabs/contacts.png";
import organizationsimg from "src/img/tabs/organizations.png";
import hoursimg from "src/img/tabs/hours.png";
import invoiceimg from "src/img/tabs/invoice.png";
import billingimg from "src/img/tabs/billing.png";
import payrollimg from "src/img/tabs/payroll.png";
import timecardimg from "src/img/tabs/timeCard.png";
import calendarimg from "src/img/tabs/calendar.png";
import offcalendarimg from "src/img/tabs/offcalendar.png";
import statusimg from "src/img/tabs/status.png";
import documentsimg from "src/img/tabs/documents.png";
import communityimg from "src/img/tabs/community.png";
import newspaperimg from "src/img/tabs/newspaper.png";
import formimg from "src/img/tabs/form.png";
import formsimg from "src/img/tabs/forms.png";
import rentalimg from "src/img/tabs/rental.png";
import timeoffimg from "src/img/tabs/vacation.png";
import trainingimg from "src/img/tabs/trainings.png";
import safetyimg from "src/img/tabs/safety.png";
import error_logimg from "src/img/tabs/error_log.png";
import databaseimg from "src/img/tabs/database.png";
import searchimg from "src/img/tabs/search.png";
import fileExplorerimg from "src/img/tabs/fileExplorer.png";
import divisionimg from "src/img/tabs/division.png";


import { 
    testerEmails
} from "src/components/common/functions";
import { Navigate, Outlet, ShouldRevalidateFunctionArgs } from "react-router-dom";
import { User } from "./authStore";

import Search from "src/components/server/Search";
import FileStorage, { fileStorageLoader } from "src/components/server/FileStorage";
import Database, { databaseTablesLoader } from "src/components/server/Database";
import ErrorLog, { errorLogLoader } from "src/components/server/Error_log";
import FileExpolrer, { fileExplorerLoader } from "src/components/server/FileExplorer";

import { usersLoader, userLoader, userAction, dispatchUserAction, userExportAction, deleteUserAction, voidUserAction, validateUserAction } from "src/components/users/actions_loaders";
import UserList from "../users/UserList";
import UserForm from "../users/UserForm";
import DispatchForm from "../users/DispatchForm";
import UserDetail from "../users/UserDetail";
import UserExportForm from "../users/UserExportForm";
import UserSettingsForm from "../users/UserSettingsForm";
import BirthDayForm from "../users/BirthdayForm";
import UsersFilterForm from "../users/UserFilterForm";

import { trainingsLoader, trainingDetailLoader, trainingDataLoader } from "../trainings/action_loaders";
import TrainingList from "../trainings/TrainingList";
import TrainingForm from "../trainings/TrainingForm";
import TrainingEditForm from "../trainings/TrainingEditForm";

import { postAction, postLoader, postsLoader } from "../community/action_loaders";
import PostList from "../community/PostList";
import PostForm from "../community/PostForm";
import PostDetail from "../community/PostDetail";

import { createFormAction, deleteFormAction, formLoader, formsLoader, updateFormAction } from "../forms/settings/actions_loaders";
import FormList from "../forms/settings/formList";
import FormDetail from "../forms/settings/formDetail";
import FormBuilder from "../forms/settings/formBuilder/FormBuilder";
import { availableFormsLoader } from "../forms/actions_loaders";
import AvailableForms from "../forms/forms";
import { deleteRecordAction, formRecordAction, formRecordLoader, formRecordsLoader, formSchemaLoader } from "../forms/records/actions_loaders";
import FormRecords from "../forms/records/formRecords";
import RecordDetail from "../forms/records/formRecord";
import Form from "../forms/records/form/Form";

import { approveTimeOffAction, deleteTimeOffAction, notifyTimeOffAction, timeOffAction, timeOffExportAction, timeOffLoader, timeOffsLoader, validateTimeOffAction, voidTimeOffAction } from "../timeOffs/actions_loaders";
import TimeOffList from "../timeOffs/TimeOffList";
import TimeOffDetail from "../timeOffs/TimeOffDetail";
import TimeOffForm from "../timeOffs/TimeOffForm";
import BalanceForm from "../timeOffs/BalanceForm";
import TimeOffFilterForm from "../timeOffs/TimeOffFilterForm";
import TimeOffExportForm from "../timeOffs/TimeOffExportForm";
import {
    approvePerDiemAction,
    deletePerDiemAction,
    notifyPerDiemAction,
    paidPerDiemAction,
    perDiemAction,
    perDiemExportAction,
    perDiemLoader,
    perDiemsLoader,
    validatePerDiemAction,
    voidPerDiemAction,
} from "../perdiem/actions_loaders";
import PerDiemList from "../perdiem/PerDiemList";
import PerDiemDetail from "../perdiem/PerDiemDetail";
import PerDiemForm from "../perdiem/PerDiemForm";
import PerDiemFilterForm from "../perdiem/PerDiemFilterForm";
import PerDiemExportForm from "../perdiem/PerDiemExportForm";
import {
    deleteVendorAction,
    validateVendorAction,
    vendorAction,
    vendorExportAction,
    vendorLoader,
    vendorsLoader,
    voidVendorAction,
} from "../vendor/actions_loaders";
import VendorList from "../vendor/VendorList";
import VendorDetail from "../vendor/VendorDetail";
import VendorForm from "../vendor/VendorForm";
import VendorFilterForm from "../vendor/VendorFilterForm";
import VendorExportForm from "../vendor/VendorExportForm";
import ServiceList from "../services/ServiceList";
import ServiceDetail from "../services/ServiceDetail";
import ServiceForm from "../services/ServiceForm";
import ServiceFilterForm from "../services/ServiceFilterForm";
import ServiceExportForm from "../services/ServiceExportForm";
import { deleteServiceAction, serviceAction, serviceExportAction, serviceLoader, servicesLoader, validateServiceAction, voidServiceAction } from "../services/actions_loaders";
import {
    approvePurchaseAction,
    deletePurchaseAction,
    notifyPurchaseAction,
    paidPurchaseAction,
    purchaseAction,
    purchaseExportAction,
    purchaseLoader,
    purchasesLoader,
    validatePurchaseAction,
    voidPurchaseAction,
} from "../purchases/actions_loaders";
import PurchaseList from "../purchases/PurchaseList";
import PurchaseDetail from "../purchases/PurchaseDetail";
import PurchaseForm from "../purchases/PurchaseForm";
import PurchaseFilterForm from "../purchases/PurchaseFilterForm";
import PurchaseExportForm from "../purchases/PurchaseExportForm";

import { deleteOrganizationAction, organizationAction, organizationExportAction, organizationLoader, organizationsLoader, validateOrganizationAction, voidOrganizationAction } from "../organizations/actions_loaders";
import OrganizationList from "src/components/organizations/OrganizationList";
import OrganizationDetail from "../organizations/OrganizationDetail";
import OrganizationForm from "../organizations/OrganizationForm";
import OrganizationFilterForm from "../organizations/OrganizationFilterForm";
import OrganizationExportForm from "../organizations/OrganizationExportForm";

import { contactAction, contactExportAction, contactLoader, contactsLoader, deleteContactAction, validateContactAction, voidContactAction } from "../contacts/actions_loaders";
import ContactList from "src/components/contacts/ContactList";
import ContactFilterForm from "../contacts/ContactFilterForm";
import ContactExportForm from "../contacts/ContactExportForm";
import ContactDetail from "../contacts/ContactDetail";
import ContactForm from "../contacts/ContactForm";

import TimeCard from "src/components/timeCard/TimeCard";
import { timeCardLoader, timeCardPunch, timeCardUpdateContent, timeCardUpdateTime, timeCardSubmit, timeCardDownload, timeCardExportAction } from "src/components/timeCard/action_loaders";
import AllTimeCardsList from "../timeCard/AllTimeCardsList";
import AllTimeCardsDetail from "../timeCard/AllTimeCardsDetail";
import { allTimeCardsDetailLoader, allTimeCardsListLoader, allTimeCardsApprovalAction, allTimeCardsUpdateTimeAction } from "../timeCard/action_loaders";

import LeadList from "../leads/LeadList";
import { deleteLeadAction, leadAction, leadExportAction, leadLoader, leadsLoader, sendLeadEmailAction, sentEmailsAction, validateLeadAction, voidLeadAction } from "../leads/actions_loaders";
import LeadFilterForm from "../leads/LeadFilterForm";
import LeadExportForm from "../leads/LeadExportForm";
import LeadDetail from "../leads/LeadDetail";
import LeadForm from "../leads/LeadForm";

import OpportunityList from "src/components/opportunities/OpportunityList";
import { deleteOpportunityAction, opportunitiesLoader, opportunityAction, opportunityExportAction, opportunityLoader, voidOpportunityAction } from "../opportunities/actions_loaders";
import OpportunityDetail from "../opportunities/OpportunityDetail";
import OpportunityForm from "../opportunities/OpportunityForm";
import OpportunityFilterForm from "../opportunities/OpportunityFilterForm";
import OpportunityExportForm from "../opportunities/OpportunityExportForm";
import ProjectList from "../projects/ProjectList";
import { deleteProjectAction, projectAction, projectExportAction, projectLoader, projectsLoader } from "../projects/actions_loaders";
import ProjectDetail from "../projects/ProjectDetail";
import ProjectForm from "../projects/ProjectForm";
import ProjectFilterForm from "../projects/ProjectFilterForm";
import ProjectExportForm from "../projects/ProjectExportForm";
import { billedAction, billingAction, billingLoader, billingsLoader } from "../billings/actions_loaders";
import Works from "../works/Works";
import WorkDetail from "../works/WorkDetail";
import WorkForm from "../works/WorkForm";
import WorkFilterForm from "../works/WorkFilterForm";
import WorkExport from "../works/WorkExport";
import {
    deleteWorkAction,
    restoreWorkAction,
    voidWorkAction,
    workAction,
    workExportAction,
    workLoader,
    worksLoader,
} from "../works/actions_loaders";
import AssignmentDetail from "../assignments/AssignmentDetail";
import AssignmentFilterForm from "../assignments/AssignmentFilterForm";
import AssignmentExport from "../assignments/AssignmentExport";
import {
    assignmentExportAction,
    assignmentLoader,
    assignmentsLoader,
    deleteAssignmentAction,
    JSASubmit,
    JobTagLoader,
    JobTagSubmit,
    restoreAssignmentAction,
    submitAssignmentAction,
    voidAssignmentAction,
    withdrawAssignmentAction,
} from "../assignments/actions_loaders";
import JobTagForm from "../assignments/JobTagForm";
import JSAForm from "../assignments/JSAForm";
import AssignmentRequiredForm from "../assignments/AssignmentRequiredForm";
import BillingFilterForm from "../billings/BillingFilterForm";

const appRoutes = (user:User) => [
    {
        show: true,
        title: "Help",
        path: "Help",
        img: searchimg,
        action: helpAction,
        children: [
            { index: true, element: <Help />, action: helpAction },
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    // -- CRM ----------------------------------------------------------
    {
        show: true,
        title: "Leads",
        path: "Leads",
        img: leadsimg, 
        children: [
            { 
                path: "", 
                element: <LeadList/>, 
                loader: leadsLoader, 
                children:[
                    { path: "Filter", element: <LeadFilterForm/>}, 
                    { path: "SendEmail", element: <Outlet/>, action: sendLeadEmailAction },
                    { path: "SentEmails", element: <Outlet/>, action: sentEmailsAction },
                    { path: "Export", element: <LeadExportForm/>, children: [{path: "Execute", element: <Outlet/>, action: leadExportAction}]}, 
                ]
            }, 
            { 
                id: "lead", 
                path: ":id", 
                loader: leadLoader,  
                children: [
                    { index : true, element : <LeadDetail/> }, 
                    { path: "Edit", element: <LeadForm keyword = "Edit"/>, action: leadAction }, 
                    { path: "*", element: <Navigate to = ".." replace/> }, 
                    { path: "Delete", element: <Outlet/>, action: deleteLeadAction }, 
                    { path: "Void", element: <Outlet/>, action: voidLeadAction }, 
                    { path: "Validate", element: <Outlet/>, action: validateLeadAction }, 
                ]
            },
            { path: "Add", element: <LeadForm keyword = "Add"/>, action: leadAction}, 
            { path: "*", element: <Navigate to = ".." replace/>}
        ]
    }, 
    {
        show: true,
        title: "Organizations",
        path: "Organizations",
        img: organizationsimg, 
        children: [
            { 
                path: "", 
                element: <OrganizationList/>, 
                loader: organizationsLoader, 
                children:[
                    { path: "Filter", element: <OrganizationFilterForm/>}, 
                    { path: "Export", element: <OrganizationExportForm/>, children: [{path: "Execute", element: <Outlet/>, action: organizationExportAction}]}, 
                ]
            }, 
            { 
                id: "organization", 
                path: ":id", 
                loader: organizationLoader, 
                shouldRevalidate: ({ actionResult }:ShouldRevalidateFunctionArgs): boolean => {
                    if (actionResult?.duplicate){
                        return false;
                    }
                    return true;
                }, 
                children: [
                    { index : true, element : <OrganizationDetail/>}, 
                    { path: "Edit", element: <OrganizationForm keyword = "Edit"/>, action: organizationAction}, 
                    { path: "*", element: <Navigate to = ".." replace/>}, 
                    { path: "Delete", element: <Outlet/>, action: deleteOrganizationAction}, 
                    { path: "Void", element: <Outlet/>, action: voidOrganizationAction}, 
                    { path: "Validate", element: <Outlet/>, action: validateOrganizationAction}, 
                ]
            },
            { path: "Add", element: <OrganizationForm keyword = "Add"/>, action: organizationAction}, 
            { path: "*", element: <Navigate to = ".." replace/>}
        ]
    },
    {
        show: true,
        title: "Contacts",
        path: "Contacts",
        img: contactsimg, 
        children: [
            { 
                path: "", 
                element: <ContactList/>, 
                loader: contactsLoader, 
                children:[
                    { path: "Filter", element: <ContactFilterForm/>}, 
                    { path: "Export", element: <ContactExportForm/>, children: [{path: "Execute", element: <Outlet/>, action: contactExportAction}]}, 
                ]
            }, 
            { 
                id: "contact", 
                path: ":id", 
                loader: contactLoader,  
                children: [
                    { index : true, element : <ContactDetail/>}, 
                    { path: "Edit", element: <ContactForm keyword = "Edit"/>, action: contactAction }, 
                    { path: "*", element: <Navigate to = ".." replace/>}, 
                    { path: "Delete", element: <Outlet/>, action: deleteContactAction}, 
                    { path: "Void", element: <Outlet/>, action: voidContactAction}, 
                    { path: "Validate", element: <Outlet/>, action: validateContactAction}, 
                ]
            },
            { path: "Add", element: <ContactForm keyword = "Add"/>, action: contactAction}, 
            { path: "*", element: <Navigate to = ".." replace/>}
        ]
    }, 
    {
        show: true,
        title: "Opportunities",
        path: "Opportunities",
        img: opportunitiesimg, 
        children: [
            { 
                path: "", 
                element: <OpportunityList/>, 
                loader: opportunitiesLoader, 
                children:[
                    { path: "Filter", element: <OpportunityFilterForm/>}, 
                    { path: "Export", element: <OpportunityExportForm/>, children: [{path: "Execute", element: <Outlet/>, action: opportunityExportAction}]}, 
                ]
            }, 
            { 
                id: "opportunity", 
                path: ":id", 
                loader: opportunityLoader,  
                children: [
                    { index : true, element : <OpportunityDetail/>}, 
                    { path: "Edit", element: <OpportunityForm keyword = "Edit"/>, action: opportunityAction }, 
                    { path: "*", element: <Navigate to = ".." replace/>}, 
                    { path: "Delete", element: <Outlet/>, action: deleteOpportunityAction}, 
                    { path: "Void", element: <Outlet/>, action: voidOpportunityAction}, 
                    { path: "Validate", element: <Outlet/>, action: validateOrganizationAction}, 
                ]
            },
            { path: "Add", element: <OpportunityForm keyword = "Add"/>, action: opportunityAction}, 
            { path: "*", element: <Navigate to = ".." replace/>}
        ]
    }, 
    {
        show: user.projects !== "no" && testerEmails.includes(user.email),
        title: "Proposals",
        path: "Proposals",
        img: opportunitiesimg,
        children: [
            {
                path: "",
                element: <ProposalList />,
                id: "Proposals",
                loader: proposalsLoader,
                children: [
                    { path: "Filter", element: <ProposalFilterForm /> },
                    { path: "Export", element: <ProposalExportForm />, children: [{ path: "Execute", element: <Outlet />, action: proposalExportAction }] },
                ],
            },
            {
                id: "Proposal",
                path: ":id",
                loader: proposalLoader,
                children: [
                    { index: true, element: <ProposalDetail /> },
                    { path: "Edit", element: <ProposalForm keyword = "Edit" />, action: proposalAction },
                    { path: "Delete", element: <Outlet />, action: deleteProposalAction },
                    { path: "Void", element: <Outlet />, action: voidProposalAction },
                    { path: "Validate", element: <Outlet />, action: validateProposalAction },
                    { path: "Notify", element: <Outlet />, action: notifyProposalAction },
                    { path: "Approve", element: <Outlet />, action: approveProposalAction },
                ],
            },
            { path: "Add", element: <ProposalForm keyword = "Add" />, action: proposalAction },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Projects",
        path: "Projects", 
        img: projectsimg,
        children: [
            {
                path: "",
                element: <ProjectList/>,
                loader: projectsLoader,
                children: [
                    { path: "Filter", element: <ProjectFilterForm/> },
                    { path: "Export", element: <ProjectExportForm/>, children: [{ path: "Execute", element: <Outlet/>, action: projectExportAction }] },
                ]
            },
            {
                id: "project",
                path: ":projectId",
                loader: projectLoader,
                children: [
                    { index: true, element: <ProjectDetail/> },
                    { path: "Edit", element: <ProjectForm keyword = "Edit"/>, action: projectAction },
                    { path: "Delete", element: <Outlet/>, action: deleteProjectAction },
                    { path: "*", element: <Navigate to = ".." replace/> },
                ]
            },
            { path: "Add", element: <ProjectForm keyword = "Add"/>, action: projectAction },
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Works",
        path: "Works", 
        img: worksimg,
        children: [
            {
                path: "",
                element: <Works/>,
                loader: worksLoader,
                children: [
                    { path: "Filter", element: <WorkFilterForm/> },
                    { path: "Export", element: <WorkExport/>, children: [{ path: "Execute", element: <Outlet/>, action: workExportAction }] },
                ]
            },
            {
                id: "work",
                path: ":workId",
                loader: workLoader,
                children: [
                    { index: true, element: <WorkDetail/> },
                    { path: "Edit", element: <WorkForm keyword = "Edit"/>, action: workAction },
                    { path: "Delete", element: <Outlet/>, action: deleteWorkAction },
                    { path: "Void", element: <Outlet/>, action: voidWorkAction },
                    { path: "Restore", element: <Outlet/>, action: restoreWorkAction },
                    { path: "*", element: <Navigate to = ".." replace/> },
                ]
            },
            { path: "Add", element: <WorkForm keyword = "Add"/>, action: workAction },
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Assignments",
        path: "Assignments", 
        img: assignmentsimg,
        children: [
            {
                path: "",
                element: <Assignments/>,
                loader: assignmentsLoader,
                children: [
                    { path: "Filter", element: <AssignmentFilterForm/> },
                    { path: "Export", element: <AssignmentExport/>, children: [{ path: "Execute", element: <Outlet/>, action: assignmentExportAction }] },
                ]
            },
            {
                id: "assignment",
                path: ":assignmentId",
                loader: assignmentLoader,
                children: [
                    { index: true, element: <AssignmentDetail/> },
                    { path: "JSA", element: <JSAForm/>, action: JSASubmit },
                    { path: "JobTag", element: <JobTagForm/>, loader: JobTagLoader, action: JobTagSubmit },
                    { path: "PreChecklist", element: <AssignmentRequiredForm formKey="PreChecklist" /> },
                    { path: "PostChecklist", element: <AssignmentRequiredForm formKey="PostChecklist" /> },
                    { path: "PreVehicle", element: <AssignmentRequiredForm formKey="PreVehicle" /> },
                    { path: "PostVehicle", element: <AssignmentRequiredForm formKey="PostVehicle" /> },
                    { path: "PreTrailer", element: <AssignmentRequiredForm formKey="PreTrailer" /> },
                    { path: "PostTrailer", element: <AssignmentRequiredForm formKey="PostTrailer" /> },
                    { path: "Submit", element: <Outlet/>, action: submitAssignmentAction },
                    { path: "Withdraw", element: <Outlet/>, action: withdrawAssignmentAction },
                    { path: "Delete", element: <Outlet/>, action: deleteAssignmentAction },
                    { path: "Void", element: <Outlet/>, action: voidAssignmentAction },
                    { path: "Restore", element: <Outlet/>, action: restoreAssignmentAction },
                    { path: "*", element: <Navigate to = ".." replace/> },
                ]
            }, 
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    {
        show: true,
        title: "Reports",
        path: "Reports",
        img: reportsimg,
        children: [
            { 
                path: "",
                element: <Reports />,
                id: "Reports",
                loader: reportsLoader,
                children: [
                    { path: "Filter", element: <ReportFilterForm/> },
                ]
            },
            {
                id: "Report",
                path: ":id",
                loader: reportLoader,
                children: [
                    { index: true, element: <Detail/> },
                    { path: "Edit", element: <ReportForm/> },
                ]
            },
            { path: "Add", element: <ReportForm/> },
            { path: "*", element: <Navigate to=".." replace /> },
        ]
    },
    // -- Approval -----------------------------------------------------
    {
        // sql optimized
        // added http cancel
        // mainStore
        show: user.projects !== "no" || user.role?.indexOf("Supervisor") > -1,
        title: "Approvals", 
        path: "Approvals",
        img: tasksimg,
        element: <Approvals/>,
        loader: approvalsLoader,
    },
    // -- Vehicle ------------------------------------------------------
    {
        // no style object, all className
        show: user.projects !== "no",
        title: "Map",
        path: "Map",
        img: mapimg,
        children: [
            {
                path: ":id?",
                element: <Maps/>,
                loader: mapsLoader,
                shouldRevalidate: ({ currentUrl, nextUrl }: ShouldRevalidateFunctionArgs): boolean => {
                    return currentUrl.search !== nextUrl.search;
                }
            },
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Fleets",
        path: "Fleets",
        img: fleetimg,
        children: [
            {
                path: "",
                element: <Fleet/>,
                loader: fleetsLoader,
                children: [
                    { path: "Settings/:settingId?/:action?", element: <FleetSettingsRoute/> },
                    { path: "Yards/:settingId?/:action?", element: <FleetYardsRoute/> },
                    { path: "Yard/:settingId?/:action?", element: <FleetYardRoute/> },
                    { path: "Inventory", element: <FleetInventoryRoute/> },
                ]
            },
            {
                id: "fleet",
                path: ":fleetId",
                loader: fleetLoader,
                children: [
                    { index: true, element: <FleetDetail/> },
                    { path: "Edit", element: <FleetEditRoute/> },
                    { path: "*", element: <Navigate to = ".." replace/> },
                ]
            },
            { path: "Add", element: <FleetAddRoute/> },
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    // -- Technician ---------------------------------------------------
    {
        show: user.assignments === "yes", 
        title: "Hours",
        path: "Hours",
        img: hoursimg,
        children: [
            { path: ":week?", element: <Hours/>, loader: hoursLoader },
            { path: "*", element: <Navigate to=".." replace /> },
        ]
    },
    {
        show: user.perDiem !== "no",
        title: "Per Diem",
        path: "PerDiem",
        img: perdiemimg,
        children: [
            {
                path: "",
                element: <PerDiemList />,
                id: "PerDiemList",
                loader: perDiemsLoader,
                children: [
                    { path: "Filter", element: <PerDiemFilterForm /> },
                    { path: "Export", element: <PerDiemExportForm />, children: [{ path: "Execute", action: perDiemExportAction }] },
                    { path: "Paid", element: <Outlet />, action: paidPerDiemAction },
                ],
            },
            {
                id: "PerDiem",
                path: ":id",
                loader: perDiemLoader,
                children: [
                    { index: true, element: <PerDiemDetail /> },
                    { path: "Edit", element: <PerDiemForm keyword = "Edit" />, action: perDiemAction },
                    { path: "Delete", element: <Outlet />, action: deletePerDiemAction },
                    { path: "Void", element: <Outlet />, action: voidPerDiemAction },
                    { path: "Validate", element: <Outlet />, action: validatePerDiemAction },
                    { path: "Notify", element: <Outlet />, action: notifyPerDiemAction },
                    { path: "Approve", element: <Outlet />, action: approvePerDiemAction },
                ],
            },
            { path: "Add", element: <PerDiemForm keyword = "Add" />, action: perDiemAction },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    // -- Coordinator --------------------------------------------------
    {
        // already internal on server
        // added http cancel

        // search local to server #
        // filter local to server #
        // export local #
        show: user.purchases !== "no",
        title: "Vendors",
        path: "Vendors",
        img: vendorimg,
        children: [
            {
                path: "",
                element: <VendorList />,
                id: "Vendors",
                loader: vendorsLoader,
                children: [
                    { path: "Filter", element: <VendorFilterForm /> },
                    { path: "Export", element: <VendorExportForm />, children: [{ path: "Execute", action: vendorExportAction }] },
                ],
            },
            {
                id: "vendor",
                path: ":id",
                loader: vendorLoader,
                children: [
                    { index: true, element: <VendorDetail /> },
                    { path: "Edit", element: <VendorForm keyword = "Edit" />, action: vendorAction },
                    { path: "Delete", element: <Outlet />, action: deleteVendorAction },
                    { path: "Void", element: <Outlet />, action: voidVendorAction },
                    { path: "Validate", element: <Outlet />, action: validateVendorAction },
                ],
            },
            { path: "Add", element: <VendorForm keyword = "Add" />, action: vendorAction },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.purchases !== "no",
        title: "Services",
        path: "Services",
        img: servicesimg,
        children: [
            {
                path: "",
                element: <ServiceList />,
                id: "Services",
                loader: servicesLoader,
                children: [
                    { path: "Filter", element: <ServiceFilterForm /> },
                    { path: "Export", element: <ServiceExportForm />, children: [{ path: "Execute", action: serviceExportAction }] },
                ],
            },
            {
                id: "service",
                path: ":id",
                loader: serviceLoader,
                children: [
                    { index: true, element: <ServiceDetail /> },
                    { path: "Edit", element: <ServiceForm keyword = "Edit" />, action: serviceAction },
                    { path: "Delete", element: <Outlet />, action: deleteServiceAction },
                    { path: "Void", element: <Outlet />, action: voidServiceAction },
                    { path: "Validate", element: <Outlet />, action: validateServiceAction },
                ],
            },
            { path: "Add", element: <ServiceForm keyword = "Add" />, action: serviceAction },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.purchases !== "no",
        title: "Purchases",
        path: "Purchases",
        img: purchasesimg,
        children: [
            {
                path: "",
                element: <PurchaseList />,
                id: "Purchases",
                loader: purchasesLoader,
                children: [
                    { path: "Filter", element: <PurchaseFilterForm /> },
                    { path: "Export", element: <PurchaseExportForm />, children: [{ path: "Execute", action: purchaseExportAction }] },
                    { path: "Paid", element: <Outlet />, action: paidPurchaseAction },
                ],
            },
            {
                id: "Purchase",
                path: ":id",
                loader: purchaseLoader,
                children: [
                    { index: true, element: <PurchaseDetail /> },
                    { path: "Edit", element: <PurchaseForm keyword = "Edit" />, action: purchaseAction },
                    { path: "Delete", element: <Outlet />, action: deletePurchaseAction },
                    { path: "Void", element: <Outlet />, action: voidPurchaseAction },
                    { path: "Validate", element: <Outlet />, action: validatePurchaseAction },
                    { path: "Notify", element: <Outlet />, action: notifyPurchaseAction },
                    { path: "Approve", element: <Outlet />, action: approvePurchaseAction },
                    { path: "Paid", element: <Outlet />, action: paidPurchaseAction },
                ],
            },
            { path: "Add", element: <PurchaseForm keyword = "Add" />, action: purchaseAction },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.calendar === "view" || true,
        title: "Calendar",
        path: "Calendar",
        img: calendarimg,
        children: [
            { path: ":week?", element: <Calendar />, loader: calendarLoader, id: "Calendar" },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Off Calendar",
        path: "OffCalendar",
        img: offcalendarimg,
        children: [
            { path: ":week?", element: <OffCalendar />, loader: offCalendarLoader, id: "OffCalendar" },
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Billings",
        path: "Billings",
        img: billingimg,
        children: [
            {
                path: "",
                element: <Billings/>,
                id: "Billings", 
                loader: billingsLoader,
                children: [
                    { path: "Export", element: <BillingsExportRoute/> },
                    { path: "Filter", element: <BillingFilterForm/>}, 
                    { path: "Billed", element: <Outlet/>, action: billedAction },
                ]
            },
            {
                id: "Billing",
                path: ":id",
                loader: billingLoader,
                children: [
                    { index: true, element: <BillingDetail/> },
                    { path: "Edit", element: <BillingForm keyword="Edit"/>, action: billingAction },
                    
                    {path: "Delete", element: <Outlet/>, action: deleteTimeOffAction }, 
                    {path: "Void", element: <Outlet/>, action: voidTimeOffAction }, 
                    {path: "Validate", element: <Outlet/>, action: validateTimeOffAction }, 
                    {path: "Notify", element: <Outlet/>, action: notifyTimeOffAction }, 
                    {path: "Approve", element: <Outlet/>, action: approveTimeOffAction }, 
                ]
            },
            { path: "Add", element: <BillingForm keyword="Add"/>, action: billingAction },
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Project Calendar",
        path: "ProjectCalendar",
        img: projectcalendarimg,
        children: [
            { path: ":week?", element: <ProjectCalendar tabTitle="Project Calendar"/> },
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Payroll",
        path: "Payroll",
        img: payrollimg,
        children: [
            { path: ":week?", element: <Payroll tabTitle="Payroll"/>, loader: payrollLoader },
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Labor Cost",
        path: "LaborCost",
        img: invoiceimg,
        children: [
            { path: "", element: <LaborCost />, loader: laborCostLoader, action: laborCostAction, id: "LaborCost" },
            { path: "*", element: <Navigate to=".." replace /> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Imported Billing",
        path: "ImportedBilling",
        img: invoiceimg,
        children: [
            { path: "", element: <ImportedBilling />, loader: importedBillingLoader, action: importedBillingAction, id: "ImportedBilling" },
            { path: "*", element: <Navigate to=".." replace /> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Job Tags",
        path: "JobTags",
        img: jobtagsimg,
        children: [
            { path: "", element: <JobTags /> },
            { path: "*", element: <Navigate to=".." replace /> },
        ]
    },
    {
        show: user.projects !== "no",
        title: "Rental Status",
        path: "RentalStatus",
        img: rentalimg,
        children: [
            { path: "", element: <RentalStatusList />, loader: rentalsLoader, id: "Rentals" },
            { path: "Add", element: <RentalForm keyword = "Add" />, action: rentalAction },
            {
                path: ":id",
                element: <RentalStatusDetail />,
                loader: rentalLoader,
                id: "Rental",
                children: [
                    { path: "Edit", element: <RentalForm keyword = "Edit" />, action: rentalAction },
                    { path: "Return", element: <ReturnForm />, action: returnAction },
                ]
            },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    // -- HR -----------------------------------------------------------
    {
        show: user.personel !== "no", 
        title: "Users", 
        path: "Users", 
        img: personelimg, 
        children: [
            { 
                path: "", 
                element: <UserList/>, 
                loader: usersLoader,
                id: "userList",
                children:[
                    {path: "Export", element: <UserExportForm/>, children: [{path: "Execute", element: <Outlet/>, action: userExportAction}]},
                    {path: "Birthday", element: <BirthDayForm/>},
                    {path: "Settings", element: <UserSettingsForm/>},
                    {path: "Filter", element: <UsersFilterForm/>},
                ]
            }, 
            { 
                id: "user", 
                path: ":id", 
                loader: userLoader, 
                children: [
                    { index : true, element : <UserDetail/>}, 
                    { path: "Edit", element: <UserForm keyword = "Edit"/>, action: userAction}, 
                    { path: "EditDispatch", element: <DispatchForm keyword = "Edit Dispatch"/>, action: dispatchUserAction}, 
                    { path: "*", element: <Navigate to = ".." replace/>}, 
                    { path: "Delete", element: <Outlet/>, action: deleteUserAction}, 
                    { path: "Void", element: <Outlet/>, action: voidUserAction}, 
                    { path: "Validate", element: <Outlet/>, action: validateUserAction}, 
                ]
            },
            { path: "Add", element: <UserForm keyword = "Add"/>, action: userAction}, 
            { path: "AddDispatch", element: <DispatchForm keyword = "Add Dispatch"/>, action: dispatchUserAction}, 
            { path: "*", element: <Navigate to = ".." replace/>}
        ]
    },
    {
        show: user.office === "yes" || user.outside === "runner",
        title: "Time Card",
        path: "TimeCard",
        img: timecardimg,
        children: [
            {path: ":week?", element: <TimeCard/>, loader: timeCardLoader, children: [
                { path: "Punch", element: <Outlet/>, action: timeCardPunch }, 
                { path: "UpdateTime", element: <Outlet/>, action: timeCardUpdateTime }, 
                { path: "UpdateContent", element: <Outlet/>, action: timeCardUpdateContent }, 
                { path: "Submit", element: <Outlet/>, action: timeCardSubmit }, 
                { path: "Download", element: <Outlet/>, action: timeCardDownload }, 
                { path: "*", element: <Navigate to = ".." replace/> }, 
            ]}, 
            { path: "*", element: <Navigate to = ".." replace/> },
        ]
    },
    {
        show: user.allOffice !== "no",
        title: "All Time Card",
        img: timecardimg,
        path: "AllTimeCards",
        children: [
            {
                path: ":week?",
                children: [
                    { index: true, element: <AllTimeCardsList />, loader: allTimeCardsListLoader },
                    { path: "Export", element: <Outlet/>, action: timeCardExportAction }, 
                    {
                        path: ":userId",
                        element: <AllTimeCardsDetail />,
                        loader: allTimeCardsDetailLoader, 
                        children: [
                            { path: "UpdateTime",    element: <Outlet />, action: allTimeCardsUpdateTimeAction },
                            { path: "Approval",       element: <Outlet />, action: allTimeCardsApprovalAction },
                            { path: "Submit",        element: <Outlet />, action: timeCardSubmit },
                            { path: "Download",      element: <Outlet />, action: timeCardDownload },
                            { path: "*",             element: <Navigate to="../.." replace /> },
                        ],
                    },
                ],
            },
            { path: "*", element: <Navigate to=".." replace /> },
        ],
    },
    // -- Outside Service ----------------------------------------------
    {
        show: user.outside === "locator", 
        title: "Locator", 
        path: "LMTimeCard", 
        img: timecardimg, 
        children: [
            { path: ":week?/:day?", element: <Locator />, loader: locatorLoader, id: "Locator" },
            { path: "*", element: <Navigate to=".." replace /> },
        ],
    },
    {
        show: user.outside === "standby", 
        title: "Standby", 
        path: "StandbyTimeCard", 
        img: timecardimg, 
        children: [
            {
                path: ":week?",
                loader: standbyLoader,
                id: "StandbyTimeCard",
                children: [
                    { index: true, element: <Standby /> },
                    { path: "Edit", element: <StandbyForm /> },
                ],
            },
            { path: "*", element: <Navigate to=".." replace /> },
        ],
    },
    {
        show: user.outsideStatus !== "no", 
        title: "L&M Status", 
        path: "OutsideStatus", 
        img: statusimg,
        children: [
            {
                path: ":week?",
                element: <AllLocatorList />,
                loader: allLocatorListLoader,
                id: "AllLocatorList",
            },
            {
                path: ":week/:userId",
                loader: allLocatorDetailLoader,
                id: "AllLocatorDetail",
                children: [
                    { index: true, element: <AllLocatorDetail /> },
                    { path: "day/:dayIndex/Edit", element: <AllLocatorDayEdit /> },
                    { path: "emergency/:dayIndex/Edit", element: <AllLocatorEmergencyEdit /> },
                    { path: "Withdraw", element: <Outlet />, action: allLocatorWithdrawAction },
                    { path: "AddEmergency", element: <Outlet />, action: allLocatorAddEmergencyAction },
                    { path: "DeleteEmergency", element: <Outlet />, action: allLocatorDeleteEmergencyAction },
                    { path: "SwitchDay", element: <Outlet />, action: allLocatorSwitchDayAction },
                    { path: "SwitchWeek", element: <Outlet />, action: allLocatorSwitchWeekAction },
                ],
            },
            { path: "*", element: <Navigate to = ".." replace /> },
        ],
    },
    {
        show: user.outsideStatus !== "no", 
        title: "Standby Status", 
        path: "OutsideStatusStandby", 
        img: statusimg,
        children: [
            {
                path: ":week?",
                element: <AllStandbyList />,
                loader: allStandbyListLoader,
                id: "AllStandbyList",
            },
            {
                path: ":week/:userId",
                loader: allStandbyDetailLoader,
                id: "AllStandbyDetail",
                children: [
                    { index: true, element: <AllStandbyDetail /> },
                    { path: "Edit", element: <StandbyForm loaderId = "AllStandbyDetail" /> },
                    { path: "SwitchWeek", element: <Outlet />, action: allStandbySwitchWeekAction },
                ],
            },
            { path: "*", element: <Navigate to = ".." replace /> },
        ],
    },
    {
        show: user.outsideStatus !== "no", 
        title: "Divisions", 
        path: "OutsideDivisions",
        img: divisionimg, 
        children: [
            { path: "", element: <OutsideDivision />, loader: outsideDivisionsLoader, action: outsideDivisionsAction, id: "OutsideDivisions" },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.outside !== "no" && user.outside !== "runner", 
        title: "Daily Call Out", 
        path: "DailyCallOut", 
        img: timecardimg,
        children: [
            { path: ":week?", element: <DailyCallOut />, loader: dailyCallOutLoader, action: dailyCallOutAction, id: "DailyCallOut" },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.outside !== "no" && user.outside !== "runner", 
        title: "Check-In", 
        path: "CheckIn", 
        img: timecardimg, 
        children: [
            { path: ":week?", element: <CheckIn />, loader: checkInLoader, action: checkInAction, id: "CheckIn" },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.outside !== "no" && user.outside !== "runner", 
        title: "Emergency OT", 
        path: "EmergencyOT", 
        img: timecardimg, 
        children: [
            { path: ":week?", element: <EmergencyOT />, loader: emergencyOTLoader, action: emergencyOTAction, id: "EmergencyOT" },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.outside !== "no" && user.outside !== "runner", 
        title: "Planned OT", 
        path: "PlannedOT", 
        img: timecardimg,
        children: [
            { path: ":week?", element: <PlannedOT />, loader: plannedOTLoader, action: plannedOTAction, id: "PlannedOT" },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.outsideStatus !== "no",
        title: "Check-In",
        path: "AllCheckIn",
        img: formimg,
        children: [
            { path: ":week?/:day?", element: <AllCheckIn />, loader: allCheckInLoader, id: "AllCheckIn" },
            { path: "Unlock", element: <Outlet />, action: unlockCheckInAction },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.outsideStatus !== "no",
        title: "Daily Call Out",
        path: "AllDailyCallOut",
        img: formimg,
        children: [
            { path: ":week?/:day?", element: <AllDailyCallOut />, loader: allDailyCallOutLoader, id: "AllDailyCallOut" },
            { path: "Unlock", element: <Outlet />, action: unlockAllDailyCallOutAction },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.outsideStatus !== "no",
        title: "Emergency OT",
        path: "AllEmergencyOT",
        img: formimg,
        children: [
            { path: ":week?", element: <AllEmergencyOT />, loader: allEmergencyOTLoader, id: "AllEmergencyOT" },
            { path: "Unlock", element: <Outlet />, action: unlockEmergencyOTAction },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.outsideStatus !== "no",
        title: "Planned OT",
        path: "AllPlannedOT",
        img: formimg,
        children: [
            { path: ":week?", element: <AllPlannedOT />, loader: allPlannedOTLoader, id: "AllPlannedOT" },
            { path: "Unlock", element: <Outlet />, action: unlockPlannedOTAction },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    // -- Executive ----------------------------------------------------
    {
        show: user.metrics !== "no",
        title: "Dashboard",
        path: "Dashboard",
        img: reportsimg,
        children: [
            { path: "", element: <Dashboard />, loader: dashboardLoader, id: "Dashboard" },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.metrics !== "no",
        title: "Profit Margin",
        path: "ProfitMargin",
        img: reportsimg,
        children: [
            { path: "", element: <ProfitMargin />, loader: profitMarginLoader, id: "ProfitMargin" },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.metrics !== "no",
        title: "Fleet Usage",
        path: "FleetUsage",
        img: reportsimg,
        children: [
            { path: "", element: <FleetUsage />, loader: fleetUsageLoader, id: "FleetUsage" },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: user.metrics !== "no",
        title: "Labor Usage",
        path: "LaborUsage",
        img: reportsimg,
        children: [
            { path: "", element: <LaborUsage />, loader: laborUsageLoader, id: "LaborUsage" },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    // -- Training ----------------------------------------------------
    {
        show: user.trainings !== "no",
        title: "Trainings",
        path: "Trainings",
        img: trainingimg,
        id: "trainings", 
        loader: trainingDataLoader, 
        children: [
            {
                index: true, 
                element: <TrainingList/>, 
                loader: trainingsLoader
            }, 
            {
                path: "Add", 
                element:  <TrainingEditForm keyword = "Add"/>
            },
            {
                path: ":id",
                id: "trainingDetail", 
                loader: trainingDetailLoader, 
                children: [
                    {
                        path: "Run", 
                        element:  <TrainingForm/>
                    },
                    { 
                        path: "Edit", 
                        element:  <TrainingEditForm keyword = "Edit"/>
                    },
                    { path: "*", element: <Navigate to = ".." replace/>}
                ]
            },
            { path: "*", element: <Navigate to = ".." replace/> }
        ]
    },
    // -- Entertainment ----------------------------------------------------
    {
        show: user.community !== "no",
        title: "Community",
        path: "Community/:id/:action",
        img: communityimg,
        children: [
            {
                loader: postsLoader, 
                index: true, 
                element: <PostList/>, 
            }, 
            { 
                id: "post", 
                path: ":id", 
                loader: postLoader, 
                children: [
                { index : true, element : <PostDetail/>},  
                { path: "Edit", element: <PostForm keyword = "Edit"/>, action: postAction}, 
                { path: "*", element: <Navigate to = ".." replace/>}
            ]},
            { path: "Add", element: <PostForm keyword = "Add"/>, action: postAction}, 
            { path: "*", element: <Navigate to = ".." replace/> }
        ]
    },
    // -- All Users ----------------------------------------------------
    {
        show: true,
        title: "Forms",
        path: "Forms",
        img: formsimg,
        children: [
            {   index: true, 
                element: <AvailableForms/>, 
                loader: availableFormsLoader

            },
            {path: ":id", children:[
                {index: true, element: <FormRecords/>, loader: formRecordsLoader}, 
                {path: "Add", element: <Form mode = "add"/>, loader: formSchemaLoader, action: formRecordAction }, 
                {path: ":record_id", id: "formRecord", loader: formRecordLoader, children: [
                    {index: true, element: <RecordDetail/>}, 
                    {path: "Edit", element: <Form mode = "edit"/>, action: formRecordAction }, 
                    {path: "Delete", element: <Outlet/>, action: deleteRecordAction }, 
                ]}, 
            ]},
            {path: "Setting", children: [
                {index: true, element: <FormList/>, loader: formsLoader }, 
                {path: "Create", element: <FormBuilder/>, action: createFormAction }, 
                {path: ":id", id: "form", loader: formLoader, children: [
                    {index: true, element: <FormDetail/>}, 
                    {path: "Edit", element: <FormBuilder/>, action: updateFormAction }, 
                    {path: "Delete", element: <Outlet/>, action: deleteFormAction }, 
                ]}, 
            ]}, 
        ]
    },
    {
        show: true,
        title: "Time Offs", 
        path: "TimeOffs", 
        img: timeoffimg, 
        children: [
            { 
                path: "",
                element: <TimeOffList/>,
                id: "TimeOffList", 
                loader: timeOffsLoader,
                children:[
                    { path: "BalanceForm", element: <BalanceForm/>}, 
                    { path: "Filter", element: <TimeOffFilterForm/>}, 
                    { path: "Export", element: <TimeOffExportForm/>, children: [{path: "Execute", action: timeOffExportAction}]}, 
                ]
            },
            {
                id: "TimeOff", 
                path: ":id", 
                loader: timeOffLoader,
                children:[
                    {index: true, element: <TimeOffDetail/>}, 
                    {path: "Edit", element: <TimeOffForm keyword = "Edit"/>, action: timeOffAction }, 
                    {path: "Delete", element: <Outlet/>, action: deleteTimeOffAction }, 
                    {path: "Void", element: <Outlet/>, action: voidTimeOffAction }, 
                    {path: "Validate", element: <Outlet/>, action: validateTimeOffAction }, 
                    {path: "Notify", element: <Outlet/>, action: notifyTimeOffAction }, 
                    {path: "Approve", element: <Outlet/>, action: approveTimeOffAction }, 
                ] 
            },
            { path: "Add", element: <TimeOffForm keyword = "Add"/>, action: timeOffAction }, 
            { path: "*", element: <Navigate to = ".." replace/>}, 
        ]
    },
    {
        show: true,
        title: "Documents",
        path: "Documents",
        img: documentsimg,
        children: [
            {
                index: true,
                element: <DocumentsPage modulePath = "/Documents" />,
                id: "Documents",
                loader: makeDocumentsLoader("c4d9f1f0b13f4d7f8e9a0b1c2d3e4f50", "Documents"),
            },
            {
                path: ":folderId",
                element: <DocumentsPage modulePath = "/Documents" />,
                id: "DocumentsFolder",
                loader: makeDocumentsLoader("c4d9f1f0b13f4d7f8e9a0b1c2d3e4f50", "Documents"),
            },
            { path: "_action/:kind", element: <Outlet />, action: makeDocumentsAction() },
            { path: ":folderId/_action/:kind", element: <Outlet />, action: makeDocumentsAction() },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: true,
        title: "Safety",
        path: "Safety",
        img: safetyimg,
        children: [
            {
                index: true,
                element: <DocumentsPage modulePath = "/Safety" />,
                id: "Safety",
                loader: makeDocumentsLoader("b3a27e3cc4f5416794e0d46c1af7d2c1", "Safety"),
            },
            {
                path: ":folderId",
                element: <DocumentsPage modulePath = "/Safety" />,
                id: "SafetyFolder",
                loader: makeDocumentsLoader("b3a27e3cc4f5416794e0d46c1af7d2c1", "Safety"),
            },
            { path: "_action/:kind", element: <Outlet />, action: makeDocumentsAction() },
            { path: ":folderId/_action/:kind", element: <Outlet />, action: makeDocumentsAction() },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    {
        show: true,
        title: "Newspaper",
        path: "Newspaper",
        img: newspaperimg,
        children: [
            {
                index: true,
                element: <NewspaperList />,
                id: "Newspaper",
                loader: newspaperLoader,
            },
            {
                path: ":folderId",
                element: <NewspaperList />,
                id: "NewspaperFolder",
                loader: newspaperLoader,
            },
            { path: "_action/:kind", element: <Outlet />, action: newspaperMutationAction },
            { path: ":folderId/_action/:kind", element: <Outlet />, action: newspaperMutationAction },
            { path: "Add", element: <NewspaperForm keyword = "Add" />, action: articleAction },
            { path: ":folderId/Add", element: <NewspaperForm keyword = "Add" />, action: articleAction },
            { path: "Article/:fileId/View", element: <NewspaperForm keyword = "View" />, loader: articleLoader },
            { path: "Article/:fileId/Edit", element: <NewspaperForm keyword = "Edit" />, loader: articleLoader, action: articleAction },
            { path: "*", element: <Navigate to = ".." replace /> },
        ]
    },
    // -- Dev Mode -----------------------------------------------------
    {
        show: testerEmails.includes(user.email),
        title: "File Storage",
        path: "FileStorage/:id",
        img: fileExplorerimg,
        children: [
            { 
                path: ":id?", 
                loader: fileStorageLoader, 
                element: <FileStorage/>
            },
            { path: "*", element: <Navigate to = ".." replace/> }
        ]
    },
    {
        show: testerEmails.includes(user.email),
        title: "Error Log",
        path: "ErrorLog",
        img: error_logimg,
        children: [
            {
                index: true, 
                element: <ErrorLog/>, 
                loader: errorLogLoader
            }, 
            { path: "*", element: <Navigate to = ".." replace/> }
        ]
    },
    {
        show: testerEmails.includes(user.email),
        title: "Search",
        path: "Search",
        img: searchimg,
        children: [
            {
                index: true, 
                element: <Search/>, 
            }, 
            { path: "*", element: <Navigate to = ".." replace/> }
        ]
    },
    {
        show: testerEmails.includes(user.email),
        title: "FileExplorer",
        path: "FileExplorer",
        img: fileExplorerimg,
        children: [
            {
                index: true, 
                loader: fileExplorerLoader, 
                element: <FileExpolrer/>, 
            }, 
            { path: "*", element: <Navigate to = ".." replace/> }
        ]
    },
    {
        show: testerEmails.includes(user.email),
        title: "Database",
        path: "Database",
        img: databaseimg,
        children: [
            {
                index: true, 
                loader: databaseTablesLoader, 
                element: <Database/>
            }, 
            { path: "*", element: <Navigate to = ".." replace/> }
        ]
    }
];
export default appRoutes;
